export default "/arbitrum.d5a58d2db6f6734e7f88e9d6c4e65961.svg";